(function($,window) {

    'use strict';

    // Load once the DOM is ready
    $(document).ready(function() {

        // Locate last chance offer button in survey
        let form$ = $('body .woocommerce-MyAccount-content form[action^="/my-account/subscription-exit-survey/"');
        let button$ = form$.length ? form$.find('.btn-last-chance-offer') : null;

        // Not on the exit survey view, bail here
        if( ! button$ || ! button$.length ) {
            return;
        }

        // Load ModeEffectPro ajax helper or bail if not present
        let ajax = window.ModeEffectPro || null;

        if( ! ajax ) {
            return;
        }

        let dialog$ = $('#me_last_chance_processed');

        // Add the click event handler
        button$.on('click',function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            // Prepare the modal view
            dialog$.find('.loader').css({ display: 'block' });
            dialog$.find('.screen').css({ display: 'block' });
            dialog$.find('h2').css({ display: 'block' });

            // Open the modal
            dialog$.jqmodal({
                blockerClass: 'me_last_chance_processed',
                escapeClose: false,
                clickClose: false,
                showClose: false
            });

            // Prepare the data
            let data = {
                subscription_id: String( form$.attr('action') ).split('/')[3],
            };

            // Process the request
            ajax.post('me_exit_survey_last_chance_accept',data,function(response) {

                // Hide the loader
                dialog$.find('.loader').css({ display: 'none' });
                dialog$.find('.screen').css({ display: 'none' });
                dialog$.find('h2').css({ display: 'none' });

                // No response, bail
                if( ! response ) {
                    return;
                }

                // Show the response
                dialog$.find('.message')
                    .html(response.data.message);

                dialog$.find('.form-actions').toggle(true);

                // On failure, add error class to message, and bail here
                if( ! response.success ) {
                    dialog$.find('.message').addClass('is_error');
                    return;
                }

                // Hide the cancellation form
                form$.hide();

            });


        });

    });

})(jQuery,window);